export const USERROLES = {
  ROLEPRIORITY1: "SUPER_ADMIN",
  ROLEPRIORITY2: "BUSINESS",
  ROLEPRIORITY3: "PERSONAL",
  ROLEPRIORITY4: "STUDENT",
  ROLEPRIORITY5: "DELEGATE_MEMBER",
};
